// src/api/portfolioApi.js
import axiosInstance from "./axios";

/**
 * Get portfolio summary for the Overview page
 */
export const getPortfolioSummary = async () => {
  try {
    const response = await axiosInstance.get("/api/portfolio/summary/");
    return response.data;
  } catch (error) {
    console.error("Error fetching portfolio summary:", error);
    throw error;
  }
};

/**
 * Sync holdings from SnapTrade
 */
export const syncHoldings = async () => {
  try {
    const response = await axiosInstance.post("/api/snaptrade/holdings/sync/");
    return response.data;
  } catch (error) {
    console.error("Error syncing holdings:", error);
    throw error;
  }
};

/**
 * Get detailed holdings
 */
export const getHoldings = async () => {
  try {
    const response = await axiosInstance.get("/api/snaptrade/holdings/");
    return response.data;
  } catch (error) {
    console.error("Error fetching holdings:", error);
    throw error;
  }
};
